import { MatInputModule } from '@angular/material/input';
import { FormlyModule } from '@ngx-formly/core';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { AsyncPipe, NgIf, NgStyle } from '@angular/common';
import { NgFor } from '@angular/common';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { MatSelectModule } from '@angular/material/select';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { DOCUMENT, NgClass } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { FuseFindByKeyPipe } from '@fuse/pipes/find-by-key/find-by-key.pipe';
import { catchError, forkJoin, map, Observable, of, Subject, switchMap, take, takeUntil, tap } from 'rxjs';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { checkModifica, authLink } from 'app/utils/boolean-input';
import { IstanzaBaseComponent } from 'app/modules/istanza-base/istanzabase.component';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { STEPPER_GLOBAL_OPTIONS, StepperSelectionEvent } from '@angular/cdk/stepper';
import { IstanzeService } from 'app/services/istanze.service';
import { Pagamento, PagopaService } from 'app/services/pagopa.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarComponent } from 'app/modules/shared/snackbar.component';
import { AllegatiService } from 'app/services/allegati.service';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
    templateUrl: './stepper.type.html',
    styleUrls: ['./stepper.type.scss'],
    standalone:true,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
  imports:[
    NgFor,
    NgIf,
    NgStyle,
    MatButtonModule,
    ReactiveFormsModule,
    FormlyMaterialModule,
    MatOptionModule,
    FormlyModule,
    MatSelectModule,
    MatInputModule,
    MatSidenavModule,
    MatIconModule,
    NgClass,
    MatProgressBarModule,
    CdkScrollable,
    MatTabsModule,
    MatStepperModule,
    AsyncPipe
  ],
  providers: [
    {
        provide: STEPPER_GLOBAL_OPTIONS,
        useValue: { showError: true, displayDefaultIndicatorType: false  }
    },
  ]
})
export class FormlyFieldStepper extends FieldType  implements OnInit, AfterViewInit {

    disabled: boolean;
    @ViewChild('stepper', {static: true}) stepper: MatStepper;

    currentStep: number = 0;
    prevStep: number = 0;
    pagopaStep: boolean = false;

    drawerMode: 'over' | 'side' = 'side';
    drawerOpened: boolean = true;
    totalSteps: number = 0;
    IstanzaBaseComponent: IstanzaBaseComponent;

    buttonClicked: boolean = false;
    pagamenti$: Observable<Pagamento[]>
    pagamenti: Pagamento[]

    user: User


    isLinear: boolean = false;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    private _changeDetectorRef = inject(ChangeDetectorRef);
    private _fuseMediaWatcherService = inject(FuseMediaWatcherService);
    private _document: Document = inject(DOCUMENT);
    private _userService = inject(UserService)
    private _istanzeService = inject(IstanzeService)
    private _pagopaService = inject(PagopaService)
    private _snackBar = inject(MatSnackBar)
    private _allegatiService = inject(AllegatiService)


    next(): void {
        if (this.stepper.selected?.stepControl?.valid) {
          this.stepper.next();
        }
      }

      prev(): void {
        this.stepper.previous();
      }




    checkModifica(){
        return checkModifica()
    }

    authLink(url: string){
        return authLink(url)
    }

    openSnackBar(messaggio: string, duration = 1000, error: string = '') {
        this._snackBar.openFromComponent(SnackBarComponent, {
            duration: duration,
            data: {
                messaggio: messaggio,
                error: error
            },
            panelClass: ['mat-toolbar', 'mat-primary'],
            horizontalPosition: 'center',
            verticalPosition: 'bottom'
        });
    }

    ngOnInit(): void
    {

        this.pagamenti$ = this._pagopaService.pagamenti$;

        this._userService.user$.subscribe(user=>this.user=user)

        // Subscribe to media changes
        this._fuseMediaWatcherService.onMediaChange$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(({matchingAliases}) =>
            {
                // Set the drawerMode and drawerOpened
                if ( matchingAliases.includes('lg') )
                {
                    this.drawerMode = 'side';
                    this.drawerOpened = true;
                }
                else
                {
                    this.drawerMode = 'over';
                    this.drawerOpened = false;
                }

                // Mark for check
                this._changeDetectorRef.markForCheck();
            });


            this.currentStep = this.options.formState.currentIndex;
            this.prevStep = this.currentStep;

            this.totalSteps = this.field.fieldGroup.length;
            //this.stepper.selectedIndex = 2
            this.IstanzaBaseComponent = this.options.formState.cmp;

    }

    ngAfterViewInit(): void {
        this.totalSteps = this.field.fieldGroup.length;
        this.pagopaStep = this.model.pagopa && this.model.tipo.pagopa ;

        // this.stepper._stepHeader.find((a,index,b) => {

        //     console.log(a, index, b)
        //     if (index >= this.totalSteps) {
        //         a._elementRef.nativeElement.onclick = (event: MouseEvent) => {
        //         console.log(event)
        //         event.preventDefault(); // Blocca il click
        //         this.stepper.selectedIndex=this.currentStep
        //         return false
        //     };
        //     }
        //     return false
        // });

        this.stepper.selectedIndexChange.subscribe(

            (index)=>{

                this.prevStep = this.currentStep;
                this.currentStep=index;
                //console.log(this.prevStep, this.currentStep)

                if (this.model.stato_id=='compilazione'){
                    if (index==this.totalSteps){
                        this.model.step_index=index
                        this.terminaCompilazione()

                        //console.log(xx)
                    }
                    else{
                        this.model.step_index=index
                        this._istanzeService.updateIstanza({id:this.model.id, step_index:index}, false).subscribe()
                    }

                }
                else if (this.model.stato_id=='riepilogo'){

                    if (index==this.totalSteps){
                        this.model.step_index=index
                        this.alPagamento()
                    }

                }





            }



        )
        //console.log('bbbbbbbbbbbbbbbbbbbbbbbbb',this.field.props.currentIndex)

        //this.IstanzaBaseComponent = this.options.formState.cmp;

        //this.currentStep = this.IstanzaBaseComponent.model.step_index || 0;
        //console.log(this.IstanzaBaseComponent.form)

        //if (this.model.is_new){
        //    this.isLinear=true
        //}

        //this.currentStep=2
        //this.stepper.selectedIndex = 2

        //this.stepper.selectedIndex=this.currentStep
        this.stepper.selectedIndex=this.model.step_index


    }


    inoltraDisabled(step:FormlyFieldConfig):boolean{
        return !this.isValid(step)
        if (!this.isValid) return true;

        //if (this.user.cf == 'STRRRT64A22D969F') return false;
        //if (this.user.cf == 'CVGDVD71M28I480K') return false;
        //if (this.user.cf == 'ZZRFBA64C09E463C') return false;
        //if (this.user.cf == 'STRRRT64A22D969F') return false;

        if  (!this.user.is_superuser) return true;

    }


    terminaCompilazione() {

        if (this.buttonClicked) return; // Impedisce ulteriori clic

        this.buttonClicked = true;

        this._allegatiService.stampaDocumento({
            istanza_id: this.model.id,
            print_model: `riepilogo-${this.model.tipo_id}`,
            field_name: 'documento_riepilogo',
            field_title: 'Documento di riepilogo',
            pdf: '1',
        }).pipe(
            //switchMap(()=>this._pagopaService.getPagamentiAzione(this.model.tipo_id, 'presentazione')),
            switchMap((result) => {
                console.log("termina compilazione", result)
                this.model.stato_id = "riepilogo";
                this.model.step_index = this.field.fieldGroup.length;
                //this.openSnackBar("Riepilogo istanza completata", 3000);
                //this.updateFormFields();
                return this._istanzeService.updateIstanza(this.model, true) //se metto true mi fa una nuova subscribe in init e evito di fare updateformfields nel subscribe... DA VEDERE!!!
            }),
            catchError((err: HttpErrorResponse) => {
                this.openSnackBar(`ERRORE ${err.error.detail}`, 5000);
                return of(null);
            })
        ).subscribe(() => {
                this.buttonClicked = true;
                this._scrollCurrentStepElementIntoView();
                this.openSnackBar("Riepilogo istanza completato", 3000);
                this._changeDetectorRef.markForCheck();

            }
        );


    }


    updateIstanza(stepIndex:number=this.currentStep, silent: boolean=true): void {
        this.model.step_index=stepIndex;
        this._istanzeService.updateIstanza(this.model, false).subscribe({
            next: (istanza) => {
                this.openSnackBar("Dati aggiornati", 1000);
                //console.log('Istanza aggiornata:', istanza.codice);
            },
            error: (err) => console.error('Errore durante il salvataggio:', err),
            //complete: () => console.log('Processo completato.')
        })
    }




    inoltraIstanza(): void {
        this._istanzeService.inoltraIstanza().subscribe(
            ()=>location.reload()
        )
    }

    alPagamento(): void {

        this._pagopaService.pagamenti$.pipe(
            take(1),
            switchMap((pagamenti: Pagamento[]) =>
                forkJoin(
                    pagamenti.map((pagamento) =>
                        this._pagopaService.savePagamento(pagamento).pipe(
                            map((result) => result['data']),
                            tap((result)=>{console.log(result);pagamento=result})
                        )
                    )
                )
            ),
            switchMap((pagamenti) => {
                console.log(pagamenti)
                this.model.stato_id = 'pagamento-presentazione';
                //this.model.step_index = this.formFields.fieldGroup.length;
                return this._istanzeService.updateIstanza(this.model, true)
            })

        ).subscribe({
            next: (risultati) => {
                this.openSnackBar("Paga con Pagopa", 3000);
                console.log('Pagamenti salvati e istanza aggiornata:', risultati);
                let top = document.getElementById('topStepper');
                if (top !== null) {
                    top.scrollIntoView();
                    top = null;
                }
            },
            error: (err) => console.error('Errore durante il processo:', err),
            complete: () => console.log('Processo completato.')
        })




/*          .subscribe(
            (pagamenti)=>{
                //this._changeDetectorRef.markForCheck();
                let top = document.getElementById('topStepper');
                if (top !== null) {
                    top.scrollIntoView();
                    top = null;
                }
            }
        ) */
    }

    tornaCompilazione(): void {

        this._istanzeService.tornaCompilazione().pipe(
            switchMap((istanza)=>this._pagopaService.delPagamentiIstanza(istanza))
        ).subscribe(
            (istanza)=>{
                this._changeDetectorRef.markForCheck();
                this.openSnackBar("Istanza in compilazione", 3000);
                let top = document.getElementById('topStepper');
                if (top !== null) {
                    top.scrollIntoView();
                    top = null;
                }
            }

        )

    }



    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }





    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Go to given step
     *
     * @param step
     */
    goToStep(step: number): boolean
    {

        /*
        if (this.form.dirty){
            if (!confirm("Ci sono modifiche non salvate, vuoi continuare? Le modifiche fatte verranno salvate")){
                this.form.reset();
                return
                //location.reload();
            }
        }*/

        this.currentStep = step

        this.prevStep = this.currentStep;

        if (this.model.is_new) return


        if (step==this.totalSteps-1){
            //this.form.disable()
            this.options.formState.disabled=true
            this.options.formState.editMode=false

        }
        else{
            //this.form.enable()
            this.options.formState.disabled=false
            this.options.formState.editMode=true
        }


        //this.props.salva(step,true)

        /*
        if (this.form.touched && !this.model.is_new){
           this.props.salva(step,true)
        }*/

        // Hack: Scrolls to top of Page after page view initialized
        let top = document.getElementById('topStepper');
        if (top !== null) {
            top.scrollIntoView();
            top = null;
        }


        // Mark for check
        this._changeDetectorRef.markForCheck();

        return true
    }

    /**
     * Go to previous step
     */
    goToPreviousStep(): void
    {
        // Return if we already on the first step
        if ( this.currentStep === 0 )
        {
            return;
        }

        // Go to step
        if(this.goToStep(this.currentStep)){

            // Scroll the current step selector from sidenav into view
            !this.model.is_new && this._scrollCurrentStepElementIntoView();
        }


    }

    /**
     * Go to next step
     */
    goToNextStep(silent: boolean=true, stepIndex:number=this.currentStep): void


    {
        // Return if we already on the last step


        if ( this.currentStep === this.totalSteps )
        {
            return;
        }


        // Go to step

        if(this.goToStep(this.currentStep)){

            // Scroll the current step selector from sidenav into view
            !this.model.is_new && this._scrollCurrentStepElementIntoView();
        }
        else{
            this.goToStep(this.currentStep)
        }

        this.updateIstanza(this.currentStep, silent)

    }

    private _scrollCurrentStepElementIntoView(): void {
        // Wrap everything into setTimeout so we can make sure that the 'current-step' class points to correct element
        setTimeout(() => {
            // Get the current step element and scroll it into view
            const currentStepElement =
            this._document.getElementsByClassName('current-step')[0];
            if (currentStepElement) {
                currentStepElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                });
            }
        });
    }


    trackByFn(index: number, item: any): any
    {
        return item.id || index;
    }

    isFormEnabled(): boolean {
        return !this.form.disabled;
    }


    /**
     * Condizione per disabilitare l'ultimo step
     */
    isLastButtonStepDisabled(): boolean {
        if (this.model.stato_id=='compilazione')
            return this.form.invalid;
        return false
    }

        /**
     * Condizione per disabilitare l'ultimo step
     */
        isLastStepDisabled(): boolean {
            return false
            return this.model.stato_id=='compilazione' || this.form.dirty;
        // return falses
    }

    /**
     * Metodo per gestire il click sullo step
     */
    onStepClick(index: number): void {
        if (index === this.totalSteps - 1 && this.isLastStepDisabled()) {
            return; // Ignora il click sull'ultimo step se è disabilitato
        }
        this.goToStep(index);
    }

    onStepChange(event: StepperSelectionEvent) {
        const previouslySelectedIndex = event.previouslySelectedIndex;
        const selectedIndex = event.selectedIndex;

        console.log(event)
        return false
        this.stepper.selectedIndex = event.previouslySelectedIndex;


    }


    pippo(e){
        console.log(e)
    }

  isValid(field: FormlyFieldConfig): boolean {

    if (!field) return true
    //return true

    // if (this.model.stato_id!='compilazione'){
    //     return true
    // }
    if (field.formControl && field.key) {
        return field.formControl.valid;
    }
    return field.fieldGroup ? field.fieldGroup.every((f) => (f && f.hide) || this.isValid(f)) || field.formControl.disabled : true ;
  }

  isValidCheck(field: FormlyFieldConfig): boolean {
    // Se non esiste il campo, consideralo non valido
    if (!field) return false;

    // Se il campo ha una chiave (quindi è un controllo individuale), verifica la validità
    if (field.formControl && field.key) {
      // Controlla se il campo è valido e non vuoto
      return field.formControl.valid && field.formControl.value !== null && field.formControl.value !== '';
    }

    // Se è un gruppo di campi, controlla la validità di ogni campo, ma considera anche il fatto che non sia nascosto o disabilitato
    return field.fieldGroup
      ? field.fieldGroup.every((f) => (f && f.hide) || this.isValidCheck(f))
      : false;
  }

  ///?????????????????????????
  onDisabled(){
    return !this.field.formControl.valid
  }
}
